import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import Notification from 'components/Notification';

const RouteWithLayout = props => {
  const { layout: Layout, component: Component, ...rest } = props;

  const modelNameProps = props.modelName ? { modelName: props.modelName } : null;

  return (
    <Route
      {...rest}
      render={matchProps => (
        <Layout>
          <Notification />
          <Component {...matchProps} {...modelNameProps} />
        </Layout>
      )}
    />
  );
};

RouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  path: PropTypes.any,
};

export default RouteWithLayout;
